<template>
	<div>
		<navigator :index="2"></navigator>
		<!-- <div class="navigationBg">
			<div class="navigation">
				<h1>
					<img class="logo" alt="筑橙科技" src="../resource/images/logo.svg">
				</h1>
				<nav class="navigator">
					<router-link to="/" class="navigatorText">首页
						<div class="block"></div>
					</router-link>
					<div @click="reminder()" class="navigatorText">产品中心
						<div class="block"></div>
					</div>
					<router-link class="navigatorText" to="/example01">应用案例
						<div class="block"></div>
					</router-link>
					<router-link to="/news01" class="navigatorText active">筑橙新闻
						<div class="block activeBlock"></div>
					</router-link>
					<router-link to="/aboutUs" class="navigatorText">关于我们
						<div class="block"></div>
					</router-link>
					<div @click="open()" class="navigatorText">在线联系
						<div class="block"></div>
					</div>
				</nav>
			</div>
		</div> -->
		<div class="localhost">
			<div class="localhostText">首页/筑橙新闻/<span style="color:#333;">{{newsDetail.titleText}}</span>
			</div>
		</div>
		<div class="example">
			<div v-if="isPerview" class="qrcodeBox" id="qrcodeBox">
				<div class="qrcode" id="qrcode"></div>
				<div class="qrcodeText">手机扫一扫即可预览移动端效果</div>
			</div>
			<div v-html="newsDetail.title"></div>
			<div class="exampleDate">{{newsDetail.createTime}}</div>
			<div v-html="newsDetail.content"></div>
			<div v-if="isPerview == false " class="getMore" style="margin-top:50px;">
				<!-- 只有在不是预览情况下才有上一个下一个 -->
				<div @click="previous()" class="previous" v-if="list.length">
					上一篇：{{currentIndex == 0 ? "没有更多啦~" : list[currentIndex*1-1].titleText}}</div>
				<div @click="next()" class="next" v-if="list.length">
					下一篇：{{currentIndex == list.length*1-1 ? "没有更多啦~~~" : list[currentIndex*1+1].titleText}}</div>
			</div>
		</div>
		<foot></foot>
	</div>
</template>

<script>
	import foot from "../components/foot"
	import navigator from "../components/navigator"
	import url from "../url.js"
	import axios from 'axios'
	import QRCode from "qrcodejs2"
	export default {
		components: {
			foot,
			navigator
		},
		name: 'news',
		data() {
			return {
				isPerview: true, //是否是预览
				id: "", //根据当前id去查询数据
				currentIndex: 0,
				list: [], //新闻列表
				newsDetail: {} //新闻详情
			}
		},
		mounted() {

			this.$nextTick(async () => {
				console.log("this", this.$route.query.id)
				console.log("this", this.$route.query)
				this.currentIndex = this.$route.query.currentIndex
				this.$session.set("currentIndex", this.currentIndex);
				this.id = this.$route.query.id
				// debugger

				this.isPerview = this.$route.query.isPerview == undefined ? true : JSON.parse(this.$route.query
					.isPerview)
				console.log("this:", this);
				if (this.$route.query.id && this.isPerview) {
					// 如果存在id就表示是需要预览
					debugger
					await this.getNewsInfo()

					// let text = `http://localhost:8081/#/news01?type=3&id=${this.id}`	//这里写扫一扫后跳转的地址和参数
					// let text = `http://120.77.31.213/mobile/#/news01?type=3&id=${this.id}` //移动端测试地址
					let text = `http://m.zanecon.cn/news?type=3&id=${this.id}` //移动端正式地址
					var qrcode = new QRCode('qrcode', {
						render: "canvas",
						text,
						width: 100,
						height: 100,
						colorDark: '#000000',
						colorLight: '#ffffff',
						// correctLevel: QRCode.CorrectLevel.H
					});
				} else {
					await this.getList()
					await this.getNewsInfo()
					try {
						this.currentIndex = this.$session.get("currentIndex") || 0
					} catch (e) {
						//TODO handle the exception
					}
				}
			})
		},
		methods: {
			async getNewsInfo() {
				await axios.get(`${url.develop}/website/mobile/journalismInfo/${this.id}`).then(res => {
					console.log("获取到的新闻详细信息是:", res)
					if (res.data.code == 200) {
						let regex = /(<([^>]+)>)/ig //去除html标签
						// this.list = [{
						// 	titleText: res.data.data.title.replace(regex, ""),
						// 	title: res.data.data.title,
						// 	content: res.data.data.content,
						// 	createTime: res.data.data.createTime
						// }]

						this.newsDetail = {
							titleText: res.data.data.title.replace(regex, ""),
							title: res.data.data.title,
							content: res.data.data.content,
							createTime: res.data.data.createTime
						}
					}
				})
			},
			previous() {
				// 上一个
				if (this.currentIndex == 0) {
					// 已经没有上一个啦
				} else {
					this.currentIndex = this.currentIndex * 1 - 1
					this.id = this.list[this.currentIndex].id
					this.$session.set("currentIndex", this.currentIndex);
					this.getNewsInfo()
					window.scrollTo(0, 0);
				}
			},
			next() {
				if (this.currentIndex == this.list.length * 1 - 1) {
					// 已经没有下一个了
				} else {
					this.currentIndex = this.currentIndex * 1 + 1
					this.id = this.list[this.currentIndex].id
					this.$session.set("currentIndex", this.currentIndex);
					this.getNewsInfo()
					window.scrollTo(0, 0);
				}
			},
			open() {
				window.open("http://qingflow.com/f/a445638c?qfchannel=Website")
			},
			reminder() {
				this.hint.hint()
			},
			async getList() {
				await axios.get(`${url.develop}/website/mobile/journalismFindPage`, {
					params: {
						pageNum: 1,
						pageSize: 999
					}
				}).then(res => {
					console.log("res:", res)
					if (res.data.code) {

						let regex = /(<([^>]+)>)/ig //去除html标签

						for (let i = 0; i < res.data.data.content.length; i++) {
							res.data.data.content[i].titleText = res.data.data.content[i].title.replace(regex,
								"");
						}

						this.list = res.data.data.content

						console.log("list:", this.list)

					}
				})
			},
		}
	}
</script>

<style scoped>
	.qrcodeText {
		box-sizing: border-box;
		padding: 4px 2px;
		display: inline-block;
		font-size: 12px;
		line-height: 16px;
		color: #444;
	}

	.qrcode {
		width: 100px;
		height: 100px;
	}

	.qrcodeBox {
		/* display: flex;
		justify-content: center; */
		position: absolute;
		right: 0;
		top: 10px;
		width: 100px;
		transform: translateX(100%);
		/* height: 256px; */
	}

	.lineBlock {
		background-color: #194c7f;
		height: 2px;
		margin: 49px auto 50px auto;
		border-radius: 2px;
	}

	.special {
		font-weight: 700;
		color: #1f5183;
	}

	.next {
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999;
		line-height: 12px;
		letter-spacing: 0.58px;
		margin-top: 10px;
		margin-bottom: 100px;
		display: block;
		transition: all .3s;
	}

	.next:hover,
	.previous:hover {
		color: #194c7f;
		cursor: pointer;
	}

	.previous {
		display: block;
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999999;
		line-height: 12px;
		letter-spacing: 0.58px;
	}

	.lastHint {
		margin: 50px auto;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #707070;
		line-height: 26px;
		letter-spacing: 0.77px;
	}

	.exampleItemTitle {
		margin-top: 50px;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		/* color: #707070; */
		color: #666;
		line-height: 26px;
		letter-spacing: 0.77px;
		margin-bottom: 30px;
	}

	.hint {
		margin-top: 15px;
		line-height: 28px;
		font-size: 20px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: center;
		color: #333;
	}

	.exampleImgList {
		display: flex;
		justify-content: space-around;
	}

	.exampleImg {
		width: 100%;
		margin-right: 45px;
	}

	.exampleImg:nth-last-child(1) {
		margin-right: 0;
	}

	.exampleDate {
		margin-top: 30px;
		line-height: 22px;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #bbb;
		/* padding-bottom: 30px; */
		box-sizing: border-box;
		/* border-bottom: 1px solid #eee; */
	}

	.example {
		width: 1040px;
		margin: 0 auto;
		/* overflow: hidden; */
		min-height: calc(100vh - 65px - 85px - 365px);
		position: relative;
	}

	/* .example::after,.example::before{
		content: "";
		overflow: hidden;
	} */

	.exampleTitle {
		margin-top: 70px;
		line-height: 42px;
		font-size: 30px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #333;
	}

	.localhostText {
		width: 1040px;
		line-height: 42px;
		font-size: 30px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #333;
		margin: 0 auto;
	}

	.localhost {
		height: 85px;
		display: flex;
		align-items: center;
		background-color: #f6f7f7;
	}

	.localhostText {
		width: 1200px;
		margin: 0 auto;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999;
	}

	.title {
		line-height: 56px;
		font-size: 40px;
		font-family: PingFang SC, PingFang SC-Heavy;
		font-weight: 800;
		text-align: left;
		color: #333;
		margin-top: 60px;
	}

	.logo {
		width: 154px;
		height: 38px;
	}

	.navigation {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.navigator {
		display: flex;
		align-items: center;
	}

	.navigatorText {
		line-height: 25px;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		color: #fff;
		margin-left: 60px;
		cursor: pointer;
		transition: all .3s;
		position: relative;
	}

	.navigatorText:nth-child(1) {
		margin-left: 0px;
	}

	.navigatorText:hover {
		color: #EA5B24;
	}

	.block {
		position: absolute;
		/* width: 33px; */
		width: 100%;
		height: 2px;
		background-color: #fff;
		transition: all .3s;
		left: 0;
		bottom: -5px;
		opacity: 0;
	}

	.navigatorText:hover .block {
		background-color: #EA5B24;
		opacity: 1;
	}

	.navigationBg {
		width: 100%;
		background-color: rgba(0, 0, 0, 0.66);
		display: flex;
		justify-content: center;
		/* position: absolute;
		left: 0;
		top: 0; */
	}

	.navigatorText {
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/pages/news.vue